import { getField, updateField } from 'vuex-map-fields'
import { getFormInitState, GlobalFormStore } from '~/mixins/globalForm'
import { prepareUrl, uri } from '~/api/uri'

export const customerFormFields = {
  display_name: { type: String },
  control_nickname: { type: String },
  status: { type: String },
  platform: { type: String },
  avg_user_response_in_minutes: { type: Number },
  avg_user_response_by_admin: { type: Boolean },
  // Options
  privacy: { type: Number },
  privacy_locked_by_admin: { type: Boolean },
  level: { type: Number },
  doc_verified: { type: Boolean },
  is_vip: { type: Boolean },
  gallery_verified: { type: Boolean },
  gallery_verified_by_admin: { type: Boolean },
  city_changed_by_admin: { type: Boolean },
  ranking: { type: Number },
  stars: { type: Number },
  stars_fixed: { type: Boolean },
  stars_changed: { type: Boolean },
  ranking_blocked_value: { type: Number },
  real_ranking: { type: Number },
  disable_purchases: { type: Boolean },
  isSilenced: { type: Boolean },
  can_invite: { type: Boolean },
  whitelisted: { type: Boolean },
  alert_media: { type: Boolean },
  block_chat_credits: { type: Boolean },
  check_task_enabled: { type: Boolean },
  check_task_duration: { type: Number },
  check_task_created_at: { type: String },
  block_chat_new: { type: Boolean },
  block_feedback: { type: Boolean },
  prime: { type: Boolean },
  prime_duration: { type: Number },
  // ID-637: START SCORE (hostess) / view score (client)
  startScore: { type: Number },
  startScoreFloor: { type: Number },
  startScoreLocked: { type: Boolean },
  viewScore: { type: Number },
  viewScoreLocked: { type: Boolean },
  // Info
  email: { type: String },
  mobile: { type: String },
  telegram: { type: String },
  telegram_disabled: { type: Boolean },
  password: { type: String },
  sms_chat: { type: Boolean },
  sms_marketing: { type: Boolean },
  email_notification: { type: Boolean },
  city_id: { type: Number },
  bday: { type: String },
  characterMsgCost: { type: Number },
  // ID-62: blocco manuale del costo hostess
  characterMsgCostLocked: { type: Boolean },
  characterMsgCostLockedValue: { type: Number },
  characterStopLoss: { type: Number },
  characterStopGain: { type: Number },
  characterCostModifier: { type: Number },
  characterHostessNationality: { type: Uint32Array },
  characterSpokenLanguages: { type: Uint32Array },
  characterHeight: { type: Number },
  characterWeight: { type: Number },
  characterSize: { type: Number },
  characterAvailableForTransfer: { type: Boolean },
  characterFreeChat: { type: Boolean },
  showAlwaysFeed: { type: Boolean },
  characterDisableCostModifier: { type: Boolean },
  hw_friend: { type: Boolean },
  tags: { type: Array },
  services: { type: Array },
  // Description
  description: { type: String },
  // Wallet
  bonusCredits: { type: Number },
  cashout: { type: Number },
  addCredits: { type: Number },
  addBoostPackageId: { type: Number }
}

const storageKey = 'CustomerEditForm'

const { gfActions, gfMutations, gfGetters } = GlobalFormStore(storageKey, customerFormFields)

export const customerEditInitState = {
  forms: []
}
export const state = () => {
  return {
    ...customerEditInitState
  }
}
export const actions = {
  ...gfActions,
  async addNote ({ commit }, { itemId, type, note }) {
    const url = prepareUrl(uri.customers.noteAdd, { userId: itemId })
    const response = await this.$axios.post(url, { type, note })
    const noteObj = response && response.data
    commit('addNote', { itemId, type, note: noteObj })
  },
  async deleteNote ({ commit }, { itemId, type, noteId }) {
    const url = prepareUrl(uri.customers.noteDelete, { userId: itemId })
    const response = await this.$axios.post(url, { type, noteId })
    if (response && response.status === 204) {
      commit('deleteNote', { itemId, type, noteId })
    }
  },
  async lockPassword ({ commit }, itemId) {
    const url = prepareUrl(uri.customers.lockPassword, { userId: itemId })
    const response = await this.$axios.post(url, {})
    if (response && response.data && response.data.status === 'ok') {
      commit('lockPassword', { itemId, data: response.data.data })
    }
  },
  async unlockPassword ({ commit }, itemId) {
    const url = prepareUrl(uri.customers.unlockPassword, { userId: itemId })
    const response = await this.$axios.post(url, {})
    if (response && response.data && response.data.status === 'ok') {
      commit('unlockPassword', { itemId })
    }
  },
  async permanentDeleteList ({ commit }, itemId) {
    const url = prepareUrl(uri.customers.permanentDeleteList, { userId: itemId })
    const response = await this.$axios.post(url, {})
    if (response && response.data && response.status === 200) {
      commit('setPermanentDeleteList', { itemId, data: response.data })
    }
  },
  async permanentDelete ({ commit }, itemId) {
    const url = prepareUrl(uri.customers.permanentDelete, { userId: itemId })
    const response = await this.$axios.delete(url, {})
    if (response && response.data && response.status === 200) {
      commit('setPermanentDeleteList', { itemId, data: response.data })
    }
  },
  async verifyEmail ({ commit }, { itemId, value }) {
    const url = prepareUrl(uri.customers.verifyEmail, { userId: itemId })
    await this.$axios.post(url, { id: itemId, email: value })
  },
  async unverifyEmail ({ commit }, { itemId, value }) {
    const url = prepareUrl(uri.customers.unverifyEmail, { userId: itemId })
    await this.$axios.post(url, { id: itemId, email: value })
  },
  async verifyMobile ({ commit }, itemId) {
    const url = prepareUrl(uri.customers.verifyMobile, { userId: itemId })
    await this.$axios.post(url, { id: itemId })
  },
  async unverifyMobile ({ commit }, itemId) {
    const url = prepareUrl(uri.customers.unverifyMobile, { userId: itemId })
    await this.$axios.post(url, { id: itemId })
  },
  async chartCredits ({ commit }, { itemId, dateRange, displayRange }) {
    const url = prepareUrl(uri.customers.chartCredits, { userId: itemId })
    const response = await this.$axios.post(url, {
      dateRange,
      displayRange
    })
    if (response && response.data && response.status === 200) {
      commit('setChartCredits', { itemId, data: response.data })
    }
  },
  approveFreeLikeMessage (_, { itemId }) {
    const url = prepareUrl(uri.customers.approveFreeLikeMessage, { userId: itemId })
    return this.$axios.post(url, {})
  },
  declineFreeLikeMessage (_, { itemId }) {
    const url = prepareUrl(uri.customers.declineFreeLikeMessage, { userId: itemId })
    return this.$axios.post(url, {})
  },
  updateFreeLikeMessage (_, { itemId, message }) {
    const url = prepareUrl(uri.customers.updateFreeLikeMessage, { userId: itemId, message })
    return this.$axios.post(url, { message })
  },
  sendSms ({ dispatch }, { itemId, mobile, message }) {
    return dispatch(
      'repos/call',
      {
        repo: 'customers.sms',
        method: 'store',
        parentId: itemId,
        payload: {
          mobile,
          message
        }
      },
      { root: true }
    )
  },
  async refreshSms ({ dispatch }, { itemId }) {
    const url = prepareUrl(uri.customers.refreshSms, { userId: itemId })
    const response = await this.$axios.post(url, {})
    if (response && response.data && response.status === 200) {
      const data = response.data
      if (data?.batch_id) {
        localStorage.setItem(`CustomerEditForm.${itemId}.smsBatch`, data.batch_id)
        dispatch('batchSms', { itemId, batchId: data.batch_id })
      }
    }
  },
  async batchSms ({ commit, dispatch, state }, { itemId }) {
    const batchId = localStorage.getItem(`CustomerEditForm.${itemId}.smsBatch`)
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0 && batchId) {
      const item = state.forms[fetchedIdx]
      const url = prepareUrl(uri.customers.batchSms, { userId: itemId, batchId })
      await dispatch('setLoadingEnable', false, { root: true })
      const response = await this.$axios.get(url)
      await dispatch('setLoadingEnable', true, { root: true })
      if (response && response.data && response.status === 200) {
        const data = response.data
        commit('setBatchInfo', { itemId, data })
        if (data.progress === 100) {
          localStorage.removeItem(`CustomerEditForm.${itemId}.smsBatch`)
          commit('flushBatchInfo', { itemId })
        } else if (!item.smsBatch.timer) {
          const timer = setInterval(() => {
            dispatch('batchSms', { itemId, batchId: data.batch_id })
          }, 1000)
          commit('setBatchInfo', { itemId, timer })
        }
      }
    }
  },
  async fetchLog ({ commit }, { itemId, type, page }) {
    let url = prepareUrl(uri.customers.log, { userId: itemId, type })
    if (page > 1) {
      url = `${url}?page=${page}`
    }
    const response = await this.$axios.get(url)
    commit('setLog', {
      itemId,
      type,
      items: response?.data?.data || [],
      pagination: response?.data?.meta?.pagination
    })
  },
  async fetchMedia ({ commit }, { itemId }) {
    const url = prepareUrl(uri.customers.media, { userId: itemId })
    const response = await this.$axios.get(url)
    commit('setMedia', {
      itemId,
      items: response?.data?.data || []
    })
  },
  async addMedia ({ commit, state }, { itemId, file }) {
    const size = 1024 * 1000
    const chunks = Math.ceil(file.size / size)
    const chanked = []
    for (let i = 0; i < chunks; i++) {
      chanked.push(file.slice(
        i * size, Math.min(i * size + size, file.size), file.type
      ))
    }
    if (chanked.length === 0) {
      return
    }

    let i = 0
    const t = chanked.length
    while (chanked.length > 0) {
      const form = new FormData()
      form.append('chunk', i)
      form.append('chunks', t)
      form.append('file', chanked.shift(), file.name)
      await this.$axios.post(
        prepareUrl(uri.customers.mediaAdd, { userId: itemId }),
        form
      )
        .then((res) => {
          if (res?.data?.id && res?.data?.type === 'video') {
            // // eslint-disable-next-line no-console
            // console.log('VIDEO UPLOADED', res.data.id, this.$media)
            this.$media.watch(res?.data?.id)
          }
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.error(e.response)
          commit('setError', {
            title: 'Media upload error',
            message: e.message
          }, { root: true })
        })
      i++
    }
  },
  async validateAllMedia (state, { itemId }) {
    await this.$axios.post(prepareUrl(uri.customers.mediaValidateAll, { userId: itemId }))
  },
  async fetchStaffNotes ({ commit }, { itemId }) {
    const url = prepareUrl(uri.customers.staffNotes, { userId: itemId })
    const response = await this.$axios.get(url)
    commit('setStaffNotes', {
      itemId,
      items: response?.data || []
    })
  },
  // [ID-338] Saves editorial_ranking with a mandatory reason via dedicated endpoint.
  // On success the caller is responsible for reloading the item (reloadItem).
  async storeEditorialRanking (_, { userId, payload }) {
    const url = prepareUrl(uri.customers.editorialRanking, { userId })
    await this.$axios.post(url, payload)
  },
  async fetchDuplicates ({ commit }, { itemId, filter }) {
    let url = prepareUrl(uri.customers.duplicates, { userId: itemId })
    if (filter) {
      const chunks = []
      filter.each((i) => {
        chunks.push(`f[${i.name}]=${i.value}`)
      })
      url = `${url}?${chunks.join('&')}`
    }
    const response = await this.$axios.get(url)
    commit('setDuplicates', {
      itemId,
      items: response?.data?.data || []
    })
  },
  async deleteSelfie ({ commit }, itemId) {
    const url = prepareUrl(uri.customers.selfie, { userId: itemId })
    await this.$axios.delete(url)
  }
}
export const mutations = {
  updateField,
  ...gfMutations,
  fill (state, { id, data }) {
    const form = data?.form
    const formData = data?.formData
    const info = data?.info
    const badges = data?.badges
    const affiliate = data?.affiliate
    const relatedProfiles = data?.related_profiles
    const utmTrack = data?.utm_track
    const createdAt = data?.created_at
    const deletedAt = data?.deleted_at
    const validatedAt = data?.validated_at
    const lastActivity = data?.last_activity
    const passwordLocked = data?.password_locked
    const staffTempPass = data?.staff_temp_pass
    const userId = data?.id
    const platform = data?.platform
    const tecMobile = data?.tec_mobile
    const supportChatId = data?.support_talk_id
    const dirtyJson = localStorage.getItem(`CustomerEditForm.${id}`)
    const dirty = dirtyJson ? JSON.parse(dirtyJson) : {}
    const dirtyKey = Object.keys(dirty).length ? JSON.stringify(dirty).hashCode() : 0
    const fetchedIdx = state.forms.findIndex(i => i.id === id)
    const item = fetchedIdx >= 0
      ? state.forms[fetchedIdx]
      : {
          id,
          type: data?.type,
          dirty,
          dirtyKey,
          oldForm: getFormInitState(customerFormFields),
          form: getFormInitState(customerFormFields),
          formData,
          info,
          badges,
          affiliate,
          relatedProfiles: {
            duplicates: relatedProfiles?.duplicates || [],
            clones: relatedProfiles?.clones || [],
            aggregated: []
          },
          log: {
            type: '',
            items: [],
            pagination: undefined
          },
          media: [],
          utmTrack,
          createdAt,
          deletedAt,
          validatedAt,
          lastActivity,
          passwordLocked,
          staffTempPass,
          userId,
          platform,
          tecMobile,
          supportChatId,
          staffNotes: {
            public: [],
            private: []
          },
          key: 0,
          // Form components refresh keys
          keys: {
            CustomerEditForm: null,
            OptionsList: null,
            InfoList: null,
            UserTitle: null,
            UserStatus: null,
            UserPlatform: null,
            Description: null,
            EditorialRanking: null // [ID-338]
          },
          isFetched: false,
          editColumnName: '',
          editColumnState: false,
          editColumnCursor: -1,
          permanentDeleteList: {},
          chartCredits: {},
          smsBatch: {
            timer: null,
            id: null,
            name: null,
            progress: null,
            failedJobs: null,
            pendingJobs: null,
            processedJobs: null,
            totalJobs: null
          }
        }
    // Fill form data
    item.form.privacy = parseInt(form?.privacy || 0, 10)
    item.form.privacy_locked_by_admin = form?.privacy_locked_by_admin || false
    item.form.level = (form && `${form.level}`) || ''
    item.form.doc_verified = (form?.doc_verified) || false
    item.form.is_vip = (form?.is_vip) || false
    item.form.gallery_verified = (form?.gallery_verified) || false
    item.form.gallery_verified_by_admin = (form?.gallery_verified_by_admin) || false
    item.form.city_changed_by_admin = (form?.city_changed_by_admin) || false
    item.form.ranking = (form?.ranking) || 0
    item.form.stars = (form?.stars) || 0
    item.form.stars_fixed = (form?.stars_fixed === 1) || false
    item.form.stars_changed = (form?.stars_changed) || false
    item.form.hw_friend = (form?.hw_friend) || false
    item.form.ranking_blocked_value = (form?.ranking_blocked_value) || 0
    item.form.real_ranking = (form?.real_ranking) || 0
    item.form.disable_purchases = !!(form?.disable_purchases)
    item.form.isSilenced = !!(form?.is_silenced)
    item.form.can_invite = !!(form?.can_invite)
    item.form.whitelisted = !!(form?.whitelisted)
    item.form.alert_media = !!(form?.alert_media)
    item.form.block_chat_credits = !!(form?.block_chat_credits)
    item.form.check_task_enabled = !!(form?.check_task_enabled)
    item.form.check_task_duration = parseInt((form?.check_task_duration))
    item.form.check_task_created_at = (form?.check_task_created_at)
    item.form.block_chat_new = !!(form?.block_chat_new)
    item.form.block_feedback = !!(form?.block_feedback)
    item.form.email = (form?.email) || ''
    item.form.mobile = (form?.mobile) || ''
    item.form.telegram = (form?.telegram) || ''
    item.form.telegram_disabled = !!(form?.telegram_disabled)
    item.form.sms_chat = !!(form?.sms_chat)
    item.form.sms_marketing = !!(form?.sms_marketing)
    item.form.email_notification = !!(form?.email_notification)
    item.form.city_id = (form?.city_id) || ''
    item.form.bday = form?.bday ? this.$dateFormat(form.bday, 'YYYY-MM-DD') : ''
    item.form.tags = (form?.tags) || []
    item.form.services = (form?.services) || []
    item.form.description = (form?.description) || ''
    item.form.display_name = (form?.display_name) || ''
    item.form.control_nickname = (form?.control_nickname) || ''
    item.form.status = (form?.status) || 0
    item.form.platform = (form?.platform) || 0
    item.form.characterMsgCost = form?.characterMsgCost || 0
    // ID-62: blocco manuale del costo hostess
    item.form.characterMsgCostLocked = !!(form?.characterMsgCostLocked)
    item.form.characterMsgCostLockedValue = form?.characterMsgCostLockedValue || 0
    item.form.prime = !!form?.prime || false
    item.form.prime_duration = form?.prime_duration || 0
    // ID-637: START SCORE (null = non gestita) / view score
    item.form.startScore = (form?.startScore ?? null)
    item.form.startScoreFloor = (form?.startScoreFloor ?? 1)
    item.form.startScoreLocked = !!(form?.startScoreLocked)
    item.form.viewScore = (form?.viewScore ?? 3)
    item.form.viewScoreLocked = !!(form?.viewScoreLocked)
    item.form.characterStopLoss = form?.characterStopLoss || 0
    item.form.characterStopGain = form?.characterStopGain || 0
    item.form.characterCostModifier = (form?.characterCostModifier) || 0
    item.form.characterHostessNationality = (form?.characterHostessNationality) || []
    item.form.characterSpokenLanguages = (form?.characterSpokenLanguages) || []
    item.form.characterHeight = (form?.characterHeight) || ''
    item.form.characterWeight = (form?.characterWeight) || ''
    item.form.characterSize = (form?.characterSize) || ''
    item.form.characterAvailableForTransfer = !!(form?.characterAvailableForTransfer)
    item.form.characterFreeChat = !!(form?.characterFreeChat)
    item.form.showAlwaysFeed = !!(form?.showAlwaysFeed)
    item.form.characterDisableCostModifier = !!(form?.characterDisableCostModifier)
    item.form.password = ''
    item.form.bonusCredits = 0
    item.form.cashout = 0
    item.form.addCredits = 0
    item.form.addBoostPackageId = 0
    item.form.avg_user_response_in_minutes = form.avg_user_response_in_minutes
    item.form.avg_user_response_by_admin = form.avg_user_response_by_admin
    // Copy form data
    Object.keys(item.form)
      .forEach((key) => {
        item.oldForm[key] = item.form[key]
      })
    // Update dirty data
    const dirtyFields = Object.keys(item.dirty)
    if (dirtyFields.length) {
      for (const dirtyField of dirtyFields) {
        item.form[dirtyField] = item.dirty[dirtyField]
      }
    }
    // Store or update data
    if (fetchedIdx >= 0) {
      item.info = info
      item.badges = badges
      item.affiliate = affiliate
      item.relatedProfiles.duplicates = relatedProfiles?.duplicates || []
      item.relatedProfiles.clones = relatedProfiles?.clones || []
      item.utmTrack = utmTrack
      item.createdAt = createdAt
      item.deletedAt = deletedAt
      item.validatedAt = validatedAt
      item.lastActivity = lastActivity
      item.passwordLocked = passwordLocked
      item.staffTempPass = staffTempPass
      item.userId = userId
      item.platform = platform
      item.tecMobile = tecMobile
      item.supportChatId = supportChatId
      item.refresh = {
        existWaitingOrders: 0,
        newOrders: 0,
        noOrders: 0
      }
      state.forms[fetchedIdx] = item
    } else {
      state.forms.push(item)
    }
  },
  addNote (state, { itemId, type, note }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      const staffNotes = state.forms[fetchedIdx].staffNotes[type]
      staffNotes.push(note)
      state.forms[fetchedIdx].staffNotes[type] = staffNotes
    }
  },
  deleteNote (state, { itemId, type, noteId }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      let staffNotes = state.forms[fetchedIdx].staffNotes[type]
      staffNotes = staffNotes.filter((n, i) => n.id !== noteId)
      state.forms[fetchedIdx].staffNotes[type] = staffNotes
    }
  },
  lockPassword (state, { itemId, data }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      const item = state.forms[fetchedIdx]
      item.passwordLocked = true
      item.staffTempPass = data?.password
      state.forms[fetchedIdx] = item
    }
  },
  unlockPassword (state, { itemId }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      const item = state.forms[fetchedIdx]
      item.passwordLocked = false
      item.staffTempPass = ''
      state.forms[fetchedIdx] = item
    }
  },
  setPermanentDeleteList (state, { itemId, data }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      const item = state.forms[fetchedIdx]
      item.permanentDeleteList = data
      state.forms[fetchedIdx] = item
    }
  },
  setChartCredits (state, { itemId, data }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      const item = state.forms[fetchedIdx]
      item.chartCredits = data
      state.forms[fetchedIdx] = item
    }
  },
  setBatchInfo (state, { itemId, data, timer }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      const item = state.forms[fetchedIdx]
      if (timer) {
        item.smsBatch.timer = timer
      }
      if (data) {
        item.smsBatch.id = data.id
        item.smsBatch.name = data.name
        item.smsBatch.progress = data.progress
        item.smsBatch.failedJobs = data.failedJobs
        item.smsBatch.pendingJobs = data.pendingJobs
        item.smsBatch.processedJobs = data.processedJobs
        item.smsBatch.totalJobs = data.totalJobs
      }
      state.forms[fetchedIdx] = item
    }
  },
  flushBatchInfo (state, { itemId }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      const item = state.forms[fetchedIdx]
      item.smsBatch.timer = null
      item.smsBatch.id = null
      item.smsBatch.name = null
      item.smsBatch.progress = null
      item.smsBatch.failedJobs = null
      item.smsBatch.pendingJobs = null
      item.smsBatch.processedJobs = null
      item.smsBatch.totalJobs = null
    }
  },
  setLog (state, { itemId, type, items, pagination }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      const log = state.forms[fetchedIdx].log
      log.type = type
      log.items = items
      log.pagination = pagination
      state.forms[fetchedIdx].log = log
    }
  },
  setMedia (state, { itemId, items }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      state.forms[fetchedIdx].media = items
    }
  },
  setStaffNotes (state, { itemId, items }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      state.forms[fetchedIdx].staffNotes = items
    }
  },
  setDuplicates (state, { itemId, items }) {
    const fetchedIdx = state.forms.findIndex(i => i.id === itemId)
    if (fetchedIdx >= 0) {
      state.forms[fetchedIdx].relatedProfiles.aggregated = items
    }
  }
}
export const getters = {
  getField,
  ...gfGetters
}
